import { createFileRoute } from '@tanstack/react-router'
import WorkspaceThemeSettings from '@/pages/settings/theme-workspace'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/theme'
)({
  component: WorkspaceThemeSettings,
})